const DEVICE_PLATFORM = {
  APPLE: 'apple',
  ANDROID: 'android',
  WINDOWS_PHONE: 'windows phone',
  UNKNOWN: 'unknown'
}

export {
  DEVICE_PLATFORM
}
